import Transformer from "@/transformers/transformer";

import moment from "moment";
moment.locale("es-mx");

export default class entriesTransformer extends Transformer {
  static fetch({
    comment,
    date_of_movement,
    entry_quantity: entryQuantity,
    output_quantity: outputQuantity,
    id,
    entry_total_cost: entryTotalCost,
    iwarehouse_supply: warehouseSupply,
    comment_system: commentSystem,
    supply_data: supplyData,
    current_quantity: currentQuantity,
    unit_cost: unitCost,
    is_entry: isEntry,
    is_output: isOutput,
    quantity_entry_output: quantityEntryOutput,
    sinister,
    order_buy: orderBuy,
    is_invoice: isInvoice,
    iwarehouse_name: iwarehouseName
  }) {
    return {
      comment,
      commentSystem,
      dateOfMovement: moment(date_of_movement).format("DD/MM/YYYY HH:mm"),
      dateOfMovementRaw: date_of_movement,
      entryQuantity,
      outputQuantity,
      quantityEntryOutput,
      id,
      entryTotalCost,
      warehouseSupply,
      supplyName: supplyData.supply_name,
      supplyUnit: supplyData.supply_unit,
      supplyCode: supplyData.supply_code,
      isEntry,
      isOutput,
      currentQuantity,
      unitCost,
      sinister,
      orderBuy,
      isInvoice: isInvoice ? "Facturado" : "Sin Facturar",
      iwarehouseName
    };
  }

  static send(data) {
    return {
      iwarehouse_supply: data.supply,
      entry_quantity: data.quantity,
      unit_cost: data.unitPrice,
      comment: data.comments,
      date_of_movement: data.movementDate,
    };
  }

  static sendWithoutOc(data) {
    return {
      supply_id: data.supply,
      iwarehouse_id: data.iwarehouseId,
      entry_quantity: data.quantity,
      unit_cost: data.unitPrice,
      comment: data.comments,
      date_of_movement: data.movementDate,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/entriesWithoutOC.js